export const NBSP_HTML = '\u00A0';

export const maskedLast4 = (last4: string) => `••••${NBSP_HTML}${last4}`;
